import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteProjectAccessEmployeeRelation = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}project_access_employee_relations/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteProjectAccessEmployeeRelation;
